import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7844329f&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=7844329f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844329f",
  null
  
)

export default component.exports